import { createDeckThunk, loadDecks, deleteDeckThunk } from '@/state/features/app';
import { useAppDispatch, useAppSelector } from '@/state/store';

export default function useDecks() {
    const decks = useAppSelector((state) => state.app.decks) || [];
    const dispatch = useAppDispatch();

    async function refreshDecks() {
        dispatch(loadDecks());
    }

    async function create(name: string) {
        const deckName = name.trim();
        if (!deckName) {
            alert('Please enter a valid deck name.');
            return;
        }

        dispatch(createDeckThunk({ name: deckName }));
    }

    async function remove(deckId: string) {
        dispatch(deleteDeckThunk(deckId));
    }

    return { decks, create, remove };
}
